import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount: number | string, currency: "TWD" | "HKD" | "USD") {
  const v = typeof amount === "string" ? Number(amount) : amount;
  return new Intl.NumberFormat("zh-Hant", {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(v);
}

export function formatDateTime(ts: number | Date) {
  const d = ts instanceof Date ? ts : new Date(ts);
  return new Intl.DateTimeFormat("zh-Hant", {
    dateStyle: "short",
    timeStyle: "short",
    timeZone: "Asia/Taipei",
  }).format(d);
}
